import { render, staticRenderFns } from "./AddMultipleMenuItems.vue?vue&type=template&id=3276cd9b&scoped=true&"
import script from "./AddMultipleMenuItems.vue?vue&type=script&lang=js&"
export * from "./AddMultipleMenuItems.vue?vue&type=script&lang=js&"
import style0 from "./AddMultipleMenuItems.vue?vue&type=style&index=0&id=3276cd9b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3276cd9b",
  null
  
)

export default component.exports